import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi";
import type {
	CloseMonthlyClosingPayload,
	MonthlyClosingRead,
	OpenMonthlyClosingMonthsRead,
} from "~/modules/timeTracking/api/monthlyClosing/monthlyClosingTypes.ts";

/** `month` is `YYYY-MM`. */
export function getMonthlyClosing(userId: string, month: string): AxiosApiResponsePromise<MonthlyClosingRead> {
	return axiosApi.get(`users/${userId}/monthly-closings/${month}`);
}

export function getOpenMonthlyClosingMonths(userId: string): AxiosApiResponsePromise<OpenMonthlyClosingMonthsRead> {
	return axiosApi.get(`users/${userId}/monthly-closings/open-months`);
}

export function closeMonthlyClosing(
	userId: string,
	payload: CloseMonthlyClosingPayload,
): AxiosApiResponsePromise<MonthlyClosingRead> {
	return axiosApi.post(`users/${userId}/monthly-closings`, payload);
}

/** `month` is `YYYY-MM`. */
export function reopenMonthlyClosingStaffing(userId: string, month: string, staffingId: string): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`users/${userId}/monthly-closings/${month}/staffings/${staffingId}`);
}

/** `month` is `YYYY-MM`. */
export function reopenMonthlyClosingNonProject(userId: string, month: string): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`users/${userId}/monthly-closings/${month}/non-project`);
}
